import { store } from "../store/store";

export const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next();
    return;
  }
  next("/login");
};

// export const mustBeAdmin = (to, from, next) => {
//   if (store.getters.isAuthenticated) {
//     if (store.getters.userIsAdmin) {
//       next();
//       return;
//     }

//     next("/employee-portal");
//     return;
//   }
//   next("/login");
// };

export const mustBeAdmin = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    if (store.getters.userIsAdmin) {
      next();
      return;
    }
  }
  next("/login");
};

export const mustBeUser = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    if (store.getters.userIsUser) {
      next();
      return;
    }
  }
  next("/login");
};

export const mustBeJobseeker = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    if (store.getters.userIsJobseeker) {
      next();
      return;
    }
  }
  next("/login");
};
